<template>
  <el-row
    justify="center"
    type="flex"
  >
    <el-col
      :xs="24"
      :lg="12"
    >
      <el-card shadow="never">
        <template #header>
          <span>Expiration du lien</span>
        </template>

        <el-row type="flex">
          <el-col
            align="center"
            :span="24"
          >
            Le lien sur lequel vous avez cliqué a expiré, retournez sur le site internet en cliquant sur le bouton ci-dessous.
          </el-col>
        </el-row>

        <el-row type="flex">
          <el-col
            align="center"
            :span="24"
          >
            <el-button
              size="small"
              type="primary"
              @click="goToWebSite()"
            >
              Continuer
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import WEBSITE_URLS from '@/services/website-target'

export default {
  methods: {
    goToWebSite () {
      window.location.assign(WEBSITE_URLS.home)
    }
  }
}
</script>
